export default "__VITE_ASSET__C7rUU8_e__"